import React, { useEffect, useState } from 'react';
const SocialImpact = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mZijKRMHRE7n5Vb8XHdgst/dia-mundial-de-los-banos-19-de-noviembre-banos-publicos-y-su-mantenimiento.jpg',
    alt: 'Señora disfrutando de agua limpia en un pozo social'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m15kgbVHRoGctpV4PqK8sD/ninos-banandose-junto-la-bomba-de-agua-en-el-patio-trasero.jpg',
    alt: 'Niños disfrutando del agua de un pozo comunitario'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fSDBi2R3cVoxJMAYLutGiU/nino-tomando-una-ducha-junto-una-piscina.jpg',
    alt: 'Niño feliz disfrutando del agua limpia'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <section id="impacto-social" className="py-16 bg-blue-50" data-id="element-163">
      <div className="container mx-auto px-4" data-id="element-164">
        <div className="text-center mb-16" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-166">
            Impacto Social
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-167">
            Juntos construimos una comunidad más consciente y solidaria, donde
            el agua es un derecho, no un privilegio.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row items-stretch gap-12" data-id="element-168">
          <div className="lg:w-1/2 w-full" data-id="element-169">
            <div className="relative aspect-[16/9] w-full overflow-hidden rounded-xl shadow-lg h-full" data-id="element-170">
              {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-171">
                  <img src={image.url} alt={image.alt} className="w-full h-full object-cover" data-id="element-172" />
                </div>)}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10" data-id="element-173">
                {images.map((_, index) => <button key={index} className={`w-2 h-2 rounded-full transition-colors ${index === currentIndex ? 'bg-white' : 'bg-white/50'}`} onClick={() => setCurrentIndex(index)} data-id="element-174" />)}
              </div>
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-175">
            <div className="grid grid-rows-2 h-full gap-8" data-id="element-176">
              <div className="bg-white p-6 rounded-xl shadow-md flex flex-col justify-center" data-id="element-177">
                <h3 className="text-2xl font-semibold text-[#2d98e2] mb-4" data-id="element-178">
                  Pozos Sociales
                </h3>
                <p className="text-gray-600" data-id="element-179">
                  A través de nuestros Pozos Sociales, llevamos agua purificada
                  a comunidades que más lo necesitan. Cada suscripción
                  contribuye directamente a la construcción y mantenimiento de
                  estos pozos, garantizando acceso a agua limpia para todos.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-md flex flex-col justify-center" data-id="element-180">
                <h3 className="text-2xl font-semibold text-[#2d98e2] mb-4" data-id="element-181">
                  QR Solidario
                </h3>
                <p className="text-gray-600" data-id="element-182">
                  Con nuestro sistema de QR Solidario, los suscriptores pueden
                  transferir parte de su consumo a personas o familias que lo
                  necesiten, creando una red de apoyo comunitario que trasciende
                  fronteras sociales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SocialImpact;